import _map from "lodash/map";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import { getPayloadForCardsByLegacyId } from '@nerdwallet/nw-api-sdk/dist/offer-sdk/credit-cards';
import { createCard } from '@nerdwallet/cc-utils/lib/offer-api/offer-api';
import nrAwareErrorHandler from '../../helpers/nr-aware-error-handler';
import { setFetchingCardData } from './compare';
/**
 * Given a list of card-ids and an instance of OfferSDK, fetches the corresponding offers from the
 * offer-api, and converts them to the legacy card objects.
 *
 * @param {OfferSDK} offerSDK - An instance of OfferSDK.
 * @param {number[]} cardIDs - An array of card-ids.
 * @returns {Promise<Object[]>} - A promise that resolves into an array of cards.
 */

var getCardDataFromOfferApi = function getCardDataFromOfferApi(offerSDK, cardIDs) {
  return function (dispatch) {
    if (cardIDs && cardIDs.length) {
      var payload = getPayloadForCardsByLegacyId(cardIDs);
      dispatch(setFetchingCardData(true));
      return offerSDK.getCreditCards(payload.getJSON()).then(function (response) {
        dispatch(setFetchingCardData(false));
        return _map(response.data.offers, function (offer) {
          return createCard(offer, payload);
        });
      }).catch(nrAwareErrorHandler('Error getting data from offer-api'));
    }

    return Promise.resolve([]);
  };
};

export default getCardDataFromOfferApi;
//# sourceMappingURL=get-card-data-from-offer-api.js.map